import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class DateService {

  private now: Date;

  constructor() {
    this.now = new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()));
  }

  today() {
    return this.now;
  }

  getVertragsBeginnDatumMinDate(expertMode: boolean): Date {
    if(expertMode){
      const minDate = moment(this.today()).subtract(7, 'days').toDate();
      return new Date(Date.UTC(minDate.getFullYear(), minDate.getMonth(), minDate.getDate()));

    }else{
      return new Date(Date.UTC(this.today().getFullYear(), this.today().getMonth(), this.today().getDate()));
    }
  }

  getVertragsBeginnDatumMaxDate(): Date {
      return new Date(Date.UTC(this.today().getFullYear(), this.today().getMonth() + 6, this.today().getDate()));
  }

  getErstzulassungsdatumMaxDate(): Date {
    return this.getVertragsBeginnDatumMaxDate();
  }
}
